/**
 * @module websocket.event.handlers.passengers.passenger-updated
 */
import { store } from '../../../../state/store'
import { setPassengerItemUpdated } from '../../../../state/websocket.slice'

export default function handlePassengerUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handlePassengerUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setPassengerItemUpdated(data))
  }
}
